export enum MediaBreakpoints {
  mobile = 'mobile',
  desktop = 'desktop',
}
